// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// Translate
import { TranslateModule } from '@ngx-translate/core';
import { PartialsModule } from '../../partials/partials.module';
// Services
import { HttpUtilsService, TypesUtilsService, LayoutUtilsService} from '../../../core/_base/crud';
// Shared
import { ActionNotificationComponent } from '../../partials/content/crud';
// Components
import { UserManagementComponent } from './user-management.component';
import { UsersListComponent } from './users/users-list/users-list.component';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { RolesListComponent } from './roles/roles-list/roles-list.component';
import { RoleEditDialogComponent } from './roles/role-edit/role-edit.dialog.component';
import { UserRolesListComponent } from './users/_subs/user-roles/user-roles-list.component';
import { ChangePasswordComponent } from './users/_subs/change-password/change-password.component';
import { AddressComponent } from './users/_subs/address/address.component';
import { SocialNetworksComponent } from './users/_subs/social-networks/social-networks.component';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatExpansionModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule
} from '@angular/material';
import {
	usersReducer,
	UserEffects,
	ProfileEffects,
	ProfilesReducer
} from '../../../core/auth';
import { CompanyListComponent } from './companies/company-list/company-list.component';
import { CompanyEditComponent } from './companies/company-edit/company-edit.component';
import { RoleGuard } from '../../../core/auth/_guards/role.guard';
import { NotificationListListComponent } from './notification-list/notification-list-list/notification-list-list.component';
import { NotificationListEditComponent } from './notification-list/notification-list-edit/notification-list-edit.component';
import { AlarmNotificationListService } from '../../../core/alarms/_services/alarm-notification-list.service';
import { InterceptService } from '../../../core/_base/crud/utils/intercept.service';


const routes: Routes = [
	{
		path: '',
		component: UserManagementComponent,
		canActivateChild: [RoleGuard],
		children: [
			{
				path: '',
				redirectTo: 'users',
				pathMatch: 'full'
			},
			{
				path: 'roles',
				component: RolesListComponent
			},
			{
				path: 'users',
				component: UsersListComponent
			},
			{
				path: 'users/add',
				component: UserEditComponent
			},
			{
				path: 'users/edit',
				component: UserEditComponent
			},
			{
				path: 'users/edit/:id',
				component: UserEditComponent
			},
			{
				path: 'companies',
				component: CompanyListComponent,
				// canActivate: [RoleGuard],
				data: {
					groups: [4,5]
				}
			},
			{
				path: 'companies/add',
				component: CompanyEditComponent,
				// canActivate: [RoleGuard],
				data: {
					groups: [4]
				}
			},
			{
				path: 'companies/edit',
				component: CompanyEditComponent,
				// canActivate: [RoleGuard],
				data: {
					groups: [4]
				}
			},
			{
				path: 'companies/edit/:id',
				component: CompanyEditComponent,
				// canActivate: [RoleGuard],
				data: {
					groups: [4]
				}
			},
			{
				path: 'lists',
				component: NotificationListListComponent
			},
			{
				path: 'lists/add',
				component: NotificationListEditComponent
			},
			{
				path: 'lists/add/:id',
				component: NotificationListEditComponent
			},
			{
				path: 'lists/edit',
				component: NotificationListEditComponent
			},
			{
				path: 'lists/edit/:id',
				component: NotificationListEditComponent
			},
		]
	}
];

@NgModule({
	imports: [
		CommonModule,
		// HttpClientModule,
		PartialsModule,
		RouterModule.forChild(routes),
		StoreModule.forFeature('users', usersReducer),
		EffectsModule.forFeature([UserEffects]),
		StoreModule.forFeature('profiles', ProfilesReducer),
		EffectsModule.forFeature([ProfileEffects]),
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
        MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
		MatDialogModule
	],
	providers: [
		InterceptService,
		// {
        // 	provide: HTTP_INTERCEPTORS,
       	//  	useClass: InterceptService,
		// 	multi: true
		// },
		{
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
		HttpUtilsService,
		TypesUtilsService,
		LayoutUtilsService,
		AlarmNotificationListService
	],
	entryComponents: [
		ActionNotificationComponent,
		RoleEditDialogComponent
	],
	declarations: [
		UserManagementComponent,
		UsersListComponent,
		UserEditComponent,
		RolesListComponent,
		RoleEditDialogComponent,
		UserRolesListComponent,
		ChangePasswordComponent,
		AddressComponent,
		SocialNetworksComponent,
		CompanyListComponent,
		CompanyEditComponent,
		NotificationListListComponent,
		NotificationListEditComponent
	]
})
export class UserManagementModule {}
